var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[_c('Toolbar3',{attrs:{"is-fluid":""}}),_c('Hero5')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }